import { Box, Grid } from '@material-ui/core'

import BlogCard from '~/components/cards/BlogCard/BlogCard'
import AdsSlot from '~/components/shared/AdSlot'
import Section from '~/components/shared/Section'

import Paths from '~/utils/paths'

import { BlogBaseArticle } from '~/models/Blog'

interface ReviewsSectionProps {
  reviewsLoading: boolean
  placeholderThree: BlogBaseArticle[]
  reviews: { articles: BlogBaseArticle[] }
}

const ReviewsSection = ({
  reviewsLoading,
  placeholderThree,
  reviews
}: ReviewsSectionProps) => {
  return (
    <Section
      displayLink
      title="Reviews"
      linkHref={Paths.newsReviews.buildSearch({ category: 'Reviews' })}
    >
      <Grid container spacing={4} justify="space-between">
        {(reviewsLoading ? placeholderThree : reviews.articles)?.map(
          (item, idx) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={4}
              key={reviewsLoading ? idx : item.id}
            >
              <BlogCard data={item} loading={reviewsLoading} fullHeight />
            </Grid>
          )
        )}
      </Grid>
      <Box display="flex" justifyContent="center" flexWrap="wrap" mt={9}>
        <AdsSlot
          slotId="gam_banner_pos1"
          sizes={[[728, 90]]}
          sizeMapping={[
            {
              viewport: [1280, 0],
              sizes: [
                [728, 90],
                [970, 90]
              ]
            },
            { viewport: [895, 0], sizes: [[728, 90], 'fluid'] },
            {
              viewport: [0, 0],
              sizes: [[300, 250], [320, 100], [320, 50], [300, 50], 'fluid']
            }
          ]}
          targetingArguments={{ pos: '1', native: 'infeed' }}
        />
      </Box>
    </Section>
  )
}

export default ReviewsSection
